import Swal from 'sweetalert2'

type TypeIcon = 'success' | 'error' | 'warning' | 'info' | 'question'; 

export const showAlert = (icon: TypeIcon, title:string, text:string) => Swal.fire({
    icon,
    title,
    text
});
